// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-login-activate-mail',
    data: () => ({
        userID: "",
        userName: "",
        code: "",
        eMailAddress: "",
        resetCode: "",
        password1: "",
        password2: "",
        errorMessage: "",
        isLoading: false
    }),
    created() {
        let tParams = new URLSearchParams();
        {
            if (this.$route.query?.code) {
                tParams.append("code", this.$route.query?.code);
            }
            if (!utils.isNullOrEmpty(this.$route.query?.userid)) {
                tParams.append("userid", this.$route.query?.userid);
            }
        }
        appHost.api.get(`identity/profile/activate-mail?${tParams.toString()}`)
            .then((e) => {
            this.userID = e.data.userID;
            this.userName = e.data.userName;
            this.code = e.data.token;
            this.eMailAddress = e.data.eMailAddress;
            this.resetCode = e.data.resetCode;
        })
            .catch((e) => {
            this.errorMessage = utils.getAxiosErrorMessage(e);
        });
    },
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
        disableLogin() {
            return utils.isEmpty(this.password1) || utils.isNullOrEmpty(this.password2);
        }
    },
    methods: {
        OnSubmit(e) {
            this.execute();
            e.preventDefault();
        },
        execute() {
            // #region Check
            if (utils.isNullOrEmpty(this.userID)) {
                return;
            }
            if (utils.isNullOrEmpty(this.password1)) {
                return;
            }
            if (this.password1 !== this.password2) {
                return;
            }
            if (this.isLoading) {
                return;
            }
            // #endregion
            // #region Reset
            this.errorMessage = "";
            // #endregion
            // #region Run
            let tData = {
                userID: this.userID,
                userName: this.userName,
                code: this.code,
                resetCode: this.resetCode,
                password: this.password1,
            };
            appHost.login.activateByMail(tData)
                .then(e => {
                // #region Run
                if (!e.isSucceded) {
                    this.errorMessage = e.errorMessage;
                }
                else {
                    this.$router.push("/");
                }
                // #endregion
                // #region local
                this.isLoading = false;
                // #endregion
            })
                .catch(e => {
                // #region local
                this.isLoading = false;
                // #endregion
            });
            // #endregion
        }
    }
});
// #endregion
